import { MembershipType } from "@app/exports/enumerations";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton"
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { FC, useContext, useEffect } from "react";
import { VolumeReportsContext } from "./VolumeReportsContext";

export const VolumeReportsMembershipFilters: FC<React.PropsWithChildren<unknown>> = () => {
    const wizardContext = useContext(VolumeReportsContext);

    // Disable the radio buttons if any selected projects do not have dual memberships.
    const disableMembershipOptions = wizardContext.projects.some(p => p.isChecked && !p.isDualMembershipProject);

    const showExcludeZeroMembershipFilter = ["specialty", "specialty-summary-zip-code"].includes(wizardContext.reportType);

    useEffect(() => {
        if (disableMembershipOptions) {
            wizardContext.setMembershipTypeFilter(MembershipType.Primary);
        }
    }, [disableMembershipOptions]);

    return (
        <section>
            <h2 className="header-m">Membership Filter</h2>
            <p>Please select the memberships to include:</p>

            <QESRadioButton
              label="Primary Membership"
              disabled={disableMembershipOptions}
              value="primary"
              checked={wizardContext.membershipTypeFilter == MembershipType.Primary}
              onChange={() => { wizardContext.setMembershipTypeFilter(MembershipType.Primary); }}
              testId={`volume-reports__membership-filters--primary`}
            />
            <QESRadioButton
              label="Secondary Membership"
              disabled={disableMembershipOptions}
              value="secondary"
              checked={wizardContext.membershipTypeFilter == MembershipType.Secondary}
              onChange={() => { wizardContext.setMembershipTypeFilter(MembershipType.Secondary); }}
              testId={`volume-reports__membership-filters--secondary`}
            />
            <QESRadioButton
              label="Primary and Secondary Membership Comparison"
              disabled={disableMembershipOptions}
              value="both"
              checked={wizardContext.membershipTypeFilter == MembershipType.Both}
              onChange={() => { wizardContext.setMembershipTypeFilter(MembershipType.Both); }}
              testId={`volume-reports__membership-filters--both`}
            />
            {showExcludeZeroMembershipFilter && (
              <QESCheckbox
                checked={wizardContext.excludeZeroMembership}
                label="Exclude 0 Membership"
                onChange={(e) => wizardContext.setExcludeZeroMembership(e.target.checked)}
                testId="volume-reports__exclude-zero-membership"
              />
            )}
        </section>
    );
}